/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FileLateral } from "./FileLateral";
import {
  FileLateralFromJSON,
  FileLateralFromJSONTyped,
  FileLateralToJSON,
  FileLateralToJSONTyped,
} from "./FileLateral";

/**
 *
 * @export
 * @interface PaginatedFileLateralList
 */
export interface PaginatedFileLateralList {
  /**
   *
   */
  count: number;
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  previous?: string | null;
  /**
   *
   */
  results: Array<FileLateral>;
}

/**
 * Check if a given object implements the PaginatedFileLateralList interface.
 */
export function instanceOfPaginatedFileLateralList(
  value: object
): value is PaginatedFileLateralList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedFileLateralListFromJSON(json: any): PaginatedFileLateralList {
  return PaginatedFileLateralListFromJSONTyped(json, false);
}

export function PaginatedFileLateralListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedFileLateralList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(FileLateralFromJSON),
  };
}

export function PaginatedFileLateralListToJSON(json: any): PaginatedFileLateralList {
  return PaginatedFileLateralListToJSONTyped(json, false);
}

export function PaginatedFileLateralListToJSONTyped(
  value?: PaginatedFileLateralList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(FileLateralToJSON),
  };
}
